import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Badge } from "@/components/ui/badge";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter,
} from "@/components/ui/dialog";
import { Plus, Trash2, Zap } from "lucide-react";
import { toast } from "sonner";

export default function QuickRepliesPage() {
  const { user } = useAuth();
  const isAdmin = user?.role === "admin";
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [shortcut, setShortcut] = useState("");
  const [text, setText] = useState("");

  const load = async () => {
    const { data } = await api.get("/quick-replies");
    setItems(data);
  };
  useEffect(() => { load(); }, []);

  const create = async () => {
    await api.post("/quick-replies", { shortcut: shortcut.replace(/^\//, ""), text });
    toast.success("Resposta rápida criada");
    setOpen(false); setShortcut(""); setText("");
    load();
  };

  const remove = async (id) => {
    if (!window.confirm("Remover esta resposta rápida?")) return;
    await api.delete(`/quick-replies/${id}`);
    load();
  };

  return (
    <div className="h-full overflow-auto p-6 lg:p-10">
      <div className="max-w-4xl mx-auto space-y-6">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="heading text-3xl font-extrabold">Respostas Rápidas</h1>
            <p className="text-sm text-muted-foreground mt-1">Atalhos prontos para as mensagens que sua equipe mais envia.</p>
          </div>
          {isAdmin && (
            <Dialog open={open} onOpenChange={setOpen}>
              <DialogTrigger asChild>
                <Button className="bg-emerald-600 hover:bg-emerald-700"><Plus className="w-4 h-4 mr-2" /> Nova resposta</Button>
              </DialogTrigger>
              <DialogContent>
                <DialogHeader><DialogTitle>Nova resposta rápida</DialogTitle></DialogHeader>
                <div className="space-y-3">
                  <div><Label>Atalho</Label><Input value={shortcut} onChange={(e) => setShortcut(e.target.value)} placeholder="ex.: guias" /></div>
                  <div><Label>Texto</Label><Textarea value={text} onChange={(e) => setText(e.target.value)} rows={5} /></div>
                </div>
                <DialogFooter><Button onClick={create} className="bg-emerald-600 hover:bg-emerald-700">Criar</Button></DialogFooter>
              </DialogContent>
            </Dialog>
          )}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {items.map((q) => (
            <Card key={q.id}>
              <CardContent className="p-4 space-y-3">
                <div className="flex items-center justify-between">
                  <Badge className="bg-emerald-100 text-emerald-800 dark:bg-emerald-950 dark:text-emerald-200"><Zap className="w-3 h-3 mr-1" /> /{q.shortcut}</Badge>
                  {isAdmin && (
                    <Button variant="ghost" size="sm" className="text-destructive" onClick={() => remove(q.id)}>
                      <Trash2 className="w-4 h-4" />
                    </Button>
                  )}
                </div>
                <p className="text-sm text-muted-foreground whitespace-pre-wrap">{q.text}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
}
